import type { ChatSummary } from '../api/types';

/**
 * Куда можно отправить то, чем поделились извне (стори 8.7).
 *
 * <p>Список тот же, что и на экране чатов, но с двумя отличиями, и оба — про смысл действия:
 *
 * <ul>
 *   <li>«Избранное» стоит первым. Поделиться с самим собой — самый частый повод: ссылка на
 *       потом, снимок в заметки. В обычном списке этого чата нет вовсе (у него своя карточка),
 *       и не показать его здесь значило бы отобрать главный сценарий.</li>
 *   <li>Канал показывается только тому, кто в нём пишет. Подписчику канал — лента для чтения;
 *       строка, которая ответит отказом сервера, в выборе адресата не нужна.</li>
 * </ul>
 */
export function shareTargets(chats: readonly ChatSummary[]): ChatSummary[] {
  const saved = chats.filter((chat) => chat.type === 'SAVED');
  const rest = chats.filter((chat) => {
    if (chat.type === 'SAVED') return false;
    if (chat.type === 'CHANNEL') return chat.canPost === true;
    return true;
  });
  return [...saved, ...rest];
}
